<template>
  <q-page padding class="container">
    <div class="row q-gutter-sm">
      <div class="col-xs-12 col-sm-8">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Configuração de Alertas
        </p>
      </div>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md container-inputs items-center"
    >
      <div class="col-2">
        <div>Unidade</div>
        <ListaUnidadesSelect />
      </div>
      <div>
        <p></p>
        <q-btn
          label="Criar Alerta"
          color="primary"
          no-caps
          :outline="!rightDrawerModalOpen"
          icon="add"
          class="q-mt-xs"
          @click="rightDrawerModalOpen = true"
        />
      </div>
    </div>

    <div class="q-mt-md">
      <div
        v-if="listaAlertasCriados.length > 0"
        class="row col-12 q-my-xl justify-between items-center"
      >
        <span
          class="texto-titulo-tabela q-ml-md text-brand-5 text-subtitle1 text-weight-bold"
        >
          Lista de Alertas Criados
        </span>
      </div>
      <q-table
        v-if="listaAlertasCriados.length > 0"
        :rows="listaAlertasCriados"
        :columns="columns"
        :loading="loading"
        color="primary"
        dense
        table-header-class="bg-accent text-weight-bold"
        class="tabela-tamanho-fixo"
        flat
        hide-bottom
        :rows-per-page-options="[0]"
      >
        <template v-slot:body="props">
          <q-tr class="text-brand-5 text-weight-bold" :props="props">
            <q-td>
              {{ props.row.entidade }}
            </q-td>
            <q-td>
              <div
                :style="
                  props.row.app == true
                    ? 'background: #e8ffec; width: fit-content; padding: 0px 5px'
                    : 'background:#ffe9e9; color: #850202; width: fit-content; padding: 0px 5px'
                "
                class="row items-center"
              >
                <div
                  v-if="props.row.app == true"
                  class="elipse q-mr-xs bg-positive"
                ></div>
                <div
                  v-else
                  class="elipse q-mr-xs"
                  style="background: red"
                ></div>
                <span
                  v-if="props.row.app == true"
                  class="row justify-center text-brand-5"
                >
                  Habilitado
                </span>
                <span v-else class="row justify-center text-brand-5">
                  Desabilitado
                </span>
              </div>
            </q-td>
            <q-td>
              <div
                :style="
                  props.row.email == true
                    ? 'background: #e8ffec; width: fit-content; padding: 0px 5px'
                    : 'background:#ffe9e9; color: #850202; width: fit-content; padding: 0px 5px'
                "
                class="row items-center"
              >
                <div
                  v-if="props.row.email == true"
                  class="elipse q-mr-xs bg-positive"
                ></div>
                <div
                  v-else
                  class="elipse q-mr-xs"
                  style="background: red"
                ></div>
                <span
                  v-if="props.row.email == true"
                  class="row justify-center text-brand-5"
                >
                  Habilitado
                </span>
                <span v-else class="row justify-center text-brand-5">
                  Desabilitado
                </span>
              </div>
            </q-td>
            <q-td>
              {{ props.row.matricula }}
            </q-td>
            <q-td>
              <div
                :style="
                  props.row.habilitado == true
                    ? 'background: #e8ffec; width: fit-content; padding: 0px 5px'
                    : 'background:#ffe9e9; color: #850202; width: fit-content; padding: 0px 5px'
                "
                class="row items-center"
              >
                <div
                  v-if="props.row.habilitado == true"
                  class="elipse q-mr-xs bg-positive"
                ></div>
                <div
                  v-else
                  class="elipse q-mr-xs"
                  style="background: red"
                ></div>
                <span
                  v-if="props.row.habilitado == true"
                  class="row justify-center text-brand-5"
                >
                  Habilitado
                </span>
                <span v-else class="row justify-center text-brand-5">
                  Desabilitado
                </span>
              </div>
            </q-td>
            <q-td>
              <div class="q-ml-lg" v-if="props.row.habilitado">
                <q-btn
                  icon="notifications_off"
                  flat
                  color="red"
                  round
                  @click="habilitarDesabilitarAlerta(props.row, false)"
                />
              </div>
              <div class="q-ml-lg" v-else>
                <q-btn
                  icon="add_alert"
                  flat
                  round
                  color="positive"
                  @click="habilitarDesabilitarAlerta(props.row, true)"
                />
              </div>
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div
        class="text-brand-5 text-weight-bold"
        style="font-size: 18px; margin-top: 100px"
        v-else
      >
        Nenhum alerta criado
      </div>
    </div>
    <Transition name="slide-fade">
      <q-card v-if="rightDrawerModalOpen" class="drawer-modal">
        <div class="row q-pa-md text-weight-bold">
          <div class="row col-12 items-center">
            <div class="row">
              <q-icon
                style="cursor: pointer"
                name="close"
                class="q-mr-md"
                size="22px"
                @click="rightDrawerModalOpen = false"
              />
              <span style="font-size: 16px">
                <span>
                  <span>Criar Alerta</span>
                </span>
              </span>
            </div>
          </div>
        </div>
        <div class="row col-12 q-mb-md q-mx-sm">
          <q-tabs
            indicator-color="black"
            v-model="tab"
            class="row col-12 text-teal"
          >
            <q-tab
              name="categoria"
              class="text-black"
              label="Criar Alerta para Categoria"
              no-caps
            />
            <q-tab
              class="text-black"
              name="tipo"
              no-caps
              label="Criar Alerta para Tipo"
            />
          </q-tabs>
        </div>
        <q-scroll-area
          v-if="tab == 'categoria'"
          style="width: 100%; height: 100%"
        >
          <div class="column col-12 no-wrap">
            <div class="q-px-md text-weight-bold">
              <div class="col">
                <SelecaoCategoriaDocumento
                  @enviarCategoria="receberCategoria"
                  :resetar="resetar"
                />
              </div>
              <div v-if="listaTipos != null" class="col q-mt-md">
                <span
                  >Tipos Vinculados a categoria: {{ listaTipos.total }}</span
                >
              </div>
              <div class="col q-mt-md">
                <span>Tipo de Alerta</span>
                <div class="q-gutter-sm">
                  <q-checkbox
                    v-model="alerta.sistema"
                    :val="true"
                    label="Sistema"
                    checked-icon="radio_button_checked"
                    unchecked-icon="radio_button_unchecked"
                    size="lg"
                  />
                  <q-checkbox
                    v-model="alerta.email"
                    :val="true"
                    label="Email"
                    checked-icon="radio_button_checked"
                    unchecked-icon="radio_button_unchecked"
                    size="lg"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col q-mt-lg">
            <div class="row justify-end q-mx-md">
              <p></p>
              <q-btn
                @click="criarAlerta('categoria', categoria?.uuid)"
                label="Criar Alerta"
                no-caps
                color="positive"
                dense
                icon="check_circle_outline"
              />
            </div>
          </div>
        </q-scroll-area>
        <q-scroll-area
          v-if="tab == 'tipo'"
          class="teste"
          style="width: 100%; height: 92%"
        >
          <div class="column col-12 no-wrap">
            <div class="q-px-md text-weight-bold">
              <div class="col">
                <SelecaoCategoriaDocumento
                  @enviarCategoria="receberCategoria"
                  :tipoCategoriaUuid="tipo?.categoriaUuid"
                  :resetar="resetar"
                />
              </div>
              <div class="col q-mt-sm">
                <SelecaoTipoDocumento
                  :categoriaUuid="categoria?.uuid"
                  @enviarTipo="receberTipo"
                />
              </div>
              <div class="col q-mt-md">
                <span>Tipo de Alerta</span>
                <div class="q-gutter-sm">
                  <q-checkbox
                    v-model="alerta.sistema"
                    :val="true"
                    label="Sistema"
                    checked-icon="radio_button_checked"
                    unchecked-icon="radio_button_unchecked"
                    size="lg"
                  />
                  <q-checkbox
                    v-model="alerta.email"
                    :val="true"
                    label="Email"
                    checked-icon="radio_button_checked"
                    unchecked-icon="radio_button_unchecked"
                    size="lg"
                  />
                </div>
              </div>
            </div>
            <div class="col q-mt-lg">
              <div class="row justify-end q-mx-md">
                <p></p>
                <q-btn
                  @click="criarAlerta('tipo', tipo?.uuid)"
                  label="Criar Alerta"
                  no-caps
                  color="positive"
                  dense
                  icon="check_circle_outline"
                />
              </div>
            </div>
          </div>
        </q-scroll-area>
      </q-card>
    </Transition>
    <div
      v-if="rightDrawerModalOpen"
      @click="rightDrawerModalOpen = false"
      class="mascara"
    ></div>
  </q-page>
</template>

<script setup>
const columns = [
  {
    name: "entidade",
    label: "Entidade",
    align: "left",
    field: "entidade",
  },
  {
    name: "sistema",
    label: "Sistema",
    align: "left",
    field: "app",
  },
  {
    name: "email",
    label: "Email",
    align: "left",
    field: "email",
  },
  {
    name: "criadoPor",
    label: "matricula",
    align: "left",
  },
  {
    name: "habilitado",
    label: "Habilitado",
    align: "left",
  },
  {
    name: "habilitadoDesabilitado",
    label: "Habilitar/Desabilitar",
    align: "left",
  },
];
import { onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

import SelecaoCategoriaDocumento from "../components/SelecaoCategoriaDocumento.vue";
import SelecaoTipoDocumento from "../components/SelecaoTipoDocumento.vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";

const store = useStore();
const quasar = useQuasar();

const tab = ref("categoria");
let rightDrawerModalOpen = ref(false);
const categoria = ref("");
const tipo = ref("");
const listaTipos = ref(null);
const alerta = ref({
  sistema: true,
  email: false,
});
const unidade = ref({
  nome: store.state.org.unidadeData.nome,
  id: store.state.org.unidadeData.id,
  logo: store.state.org.unidadeData.logo,
});
const resetar = ref(0);
const listaAlertasCriados = ref([]);
const optionsUnidade = ref([]);
let loading = ref(false);

const receberCategoria = (value) => {
  if (value == null) {
    categoria.value = "";
    return;
  }
  categoria.value = value;
};

const receberTipo = (value) => {
  if (value == null) {
    tipo.value = "";
    return;
  }
  tipo.value = value;
};

const listarAlertas = async () => {
  try {
    loading.value = true;
    const response = await store.dispatch("documento/listarAlertasCriados");
    listaAlertasCriados.value = response.data.resultado.message;
    loading.value = false;
  } catch (error) {
    console.log(error);
  }
};

const listarTipos = async () => {
  try {
    const response = await store.dispatch("documento/listarTipos", {
      unidadeId: store.state.org.unidadeData.id,
      categoriaUuid: categoria.value.uuid,
      perPage: 100,
    });
    listaTipos.value = response.data.resultado;
  } catch (error) {
    console.log(error);
  }
};

const criarAlerta = async (entidade, entidadeUuid) => {
  if (entidade == "categoria" && categoria.value == "") {
    quasar.notify({
      message: "Selecione uma categoria.",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    return;
  }
  if (entidade == "tipo" && tipo.value == "") {
    quasar.notify({
      message: "Selecione um tipo.",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    return;
  }
  if (alerta.value.sistema == false && alerta.value.email == false) {
    quasar.notify({
      message: "Selecione ao menos um tipo de alerta.",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    return;
  }
  try {
    await store.dispatch("documento/criarAlerta", {
      entidade: entidade,
      entidadeUuid: entidadeUuid,
      app: alerta.value.sistema,
      email: alerta.value.email,
      habilitado: true,
    });
    resetar.value++;
    listarAlertas();
    rightDrawerModalOpen.value = false;
    quasar.notify({
      message: "Alerta criado com sucesso.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  } catch (error) {
    quasar.notify({
      message: "Erro ao criar alerta.",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const habilitarDesabilitarAlerta = async (alerta, acao) => {
  try {
    await store.dispatch("documento/criarAlerta", {
      entidade: alerta.entidade,
      entidadeUuid: alerta.entidadeUuid,
      app: alerta.app,
      email: alerta.email,
      habilitado: acao,
    });
    listarAlertas();
    if (acao) {
      quasar.notify({
        message: "Alerta habilitado com sucesso.",
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    } else {
      quasar.notify({
        message: "Alerta desabilitado com sucesso.",
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    }
  } catch (error) {
    if (acao) {
      quasar.notify({
        message: "Erro ao habilitar alerta.",
        color: "negative",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    } else {
      quasar.notify({
        message: "Erro ao desabilitar alerta.",
        color: "negative",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    }
  }
};

const listarUnidades = async () => {
  try {
    const response = await store.dispatch("org/listarUnidades");
    optionsUnidade.value = response.listaUnidades;
    unidade.value = {
      nome: store.state.org.unidadeData.nome,
      id: store.state.org.unidadeData.id,
      logo: store.state.org.unidadeData.logo,
    };
  } catch (error) {
    console.log(error);
  }
};

watch(
  () => categoria.value?.uuid,
  () => {
    if (categoria.value?.uuid) {
      listarTipos();
      return;
    }
    listaTipos.value = null;
  }
);
watch(
  () => store.state.org.unidadeData.id,
  () => {
    listarAlertas();
  }
);
watch(
  () => tab.value,
  () => {
    listaTipos.value = null;
    categoria.value = "";
    tipo.value = "";
    alerta.value = {
      sistema: true,
      email: false,
    };
  }
);
onMounted(() => {
  listarAlertas();
  listarUnidades();
});
</script>

<style scoped>
.container {
  height: 100%;
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: calc(100% - 10px);
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
.card {
  border: 1px solid #707070;
  border-radius: 5px;
}
.text-grid-table {
  font-size: 18px;
}
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 100%;
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 85%;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 80%;
    top: 107px;
  }
}
</style>
